import { Component, Input, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'validation-error',
    imports: [],
    templateUrl: './validation-error.component.html',
    styleUrl: './validation-error.component.scss'
})
export class ValidationErrorComponent {
  @Input() form!: FormGroup;
  @Input() validation!: {[key: string]: string};
  @Input() controlName: string = '';

  getValidationErrors(): string | null{
    const form = this.form;
    const control = this.controlName;

    if (form.get(control)?.invalid && form.get(control)?.dirty) {
      // loop through all keys from valiadtion
      for(const errorKey in this.validation){
        if(form.get(control)?.errors?.[errorKey]) {
          //return error message
         return this.validation[errorKey]
        }
      }
    }

    return null;
  }

}
